/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Cookie from 'js-cookie';
import { addCommasToMoney } from '../../helper/index';

/**
 * @class UserUnTrackInvestmentCard
 */
class UserUnTrackInvestmentCard extends Component {

  onClickUserInvest = () => {
    const {
      amount,
      status,
      title,
      maturityDate,
      tenorInDays,
      dateCreated,
      investmentId,
      actionType
    } = this.props;
    const investObj = {
      amount,
      status,
      title,
      maturityDate,
      tenorInDays,
      dateCreated,
      investmentId,
      actionType
    };
    Cookie.set('investObj', investObj);
  }

  /**
   *
   * @returns {*} - render
   */
  render() {
    const {
      amount,
      status,
      title,
      tenorInDays,
    } = this.props;

    const mainAmount = addCommasToMoney(amount);
    
    return (
      <div className="savings_plan_for_interest_options notontrack">
        <a href="/withdraw-invest"
          style={{ textDecoration: 'none' }}
          onClick={this.onClickUserInvest}
        >
          <div className="header">
            <h5>
              {
                title === 'mtLip' ? 'Meristem Treasury Linked Portfolio' : ''
                }
            </h5>
          </div>
          <div className="savings_breakdown_interest">

            <div>
              <span>
                Amount
              </span>
              <p>
                {`₦${mainAmount}`}
              </p>
            </div>
            <div>
              <span>
                    Status
              </span>
              <p>
                {status}
              </p>
            </div>
            <div>
              <span>
                Tenor In Days
              </span>
              <p>
                { tenorInDays }
              </p>
            </div>
          </div>
          <div className="savings_interest_progress">
            <div className="savings_progresss_text">
              <div>
                <span />
              </div>
            </div>
            <div className="progress">
              <div className="progress-bar" style={{ width: '70%' }} />
            </div>
          </div>
        </a>
      </div>
    );
  }
}

UserUnTrackInvestmentCard.propTypes = {
  amount: PropTypes.string,
  title: PropTypes.string,
  status: PropTypes.string,
  maturityDate: PropTypes.any,
  tenorInDays: PropTypes.string,
  dateCreated: PropTypes.any,
  investmentId: PropTypes.any,
  actionType: PropTypes.any,
};

export default UserUnTrackInvestmentCard;
